<user-ingot-base [user]="user" [link]="link">
  @if (telephone) {
  <div>
    <icon type="phone"></icon>
    <a href="tel:{{ telephone }}" tabindex="-1">{{ telephone | telephone }}</a>
  </div>
  }
  <div>
    <icon type="envelope-fill"></icon>
    <a href="mailto:{{ user.email }}" tabindex="-1">{{ user.email }}</a>
  </div>
</user-ingot-base>
